import React from "react";
import PdfPreviewLayout from "../../layouts/PdfPreviewLayout.tsx";
import { styles } from "../estimateStyle.tsx";

interface PdfPreviewSlotProps {
  blob: Blob | null;
}

export default function PdfPreviewSlot({ blob }: PdfPreviewSlotProps) {
  return (
    <div style={styles.container}>
      {blob ? <PdfPreviewLayout blob={blob} />
        : (
        <p style={styles.largeText}>
          미리보기가 없습니다.
        </p>
      )}
    </div>
  );
}
